import { useEffect, useRef } from 'react'

import { ChatBotContentProps } from '../../../types/chatbot'
import MessageComponent from './messages'
import StarsBot from '../../../assets/Avatar.svg'
import styles from '../styles/chatbot.module.scss'

const ChatBotContent = ({
  disclaimer,
  messages,
  handleOptionButtonClick,
  handleFeedbackButtonClick,
  isLoading
}: ChatBotContentProps) => {
  const messagesEndRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    messagesEndRef.current!.scrollIntoView({ behavior: 'smooth' })
  }, [messages])

  return (
    <div className={styles['chatbot-content']} data-testid='chatbot-content'>
      <i className={styles.disclaimer}>
        {disclaimer} <a href='#'>Learn more</a>
      </i>
      <div className={styles['message-area']}>
        {messages.map((msg, index) => (
          <div
            key={index}
            className={`${styles.message} ${styles[msg.sender]}`}
            data-testid={`Message${msg.sender}`}
          >
            <MessageComponent
              msg={msg}
              handleOptionButtonClick={handleOptionButtonClick}
              handleFeedbackButtonClick={handleFeedbackButtonClick}
            />
          </div>
        ))}
        {isLoading && (
          <div className={`${styles.message} ${styles.bot}`}>
            <img src={StarsBot} alt='Bot Avatar' className={styles.avatar} />
            <div className={`${styles['message-container']} ${styles.loading}`}>
              <div className={styles['message-text']}>
                <div className={styles['loading-message']}>
                  <div className={styles.dot}>.</div>
                  <div className={styles.dot}>.</div>
                  <div className={styles.dot}>.</div>
                  <div className={styles.dot}>.</div>
                  <div className={styles.dot}>.</div>
                  <div className={styles.dot}>.</div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div ref={messagesEndRef}></div>
      </div>
    </div>
  )
}

export default ChatBotContent
